import PdfSubmission from "./PdfSubmission";

const { register } = require("@lpm/pug-components/dist/register");

register("PdfSubmission/PdfSubmission", PdfSubmission);
